import { HandHeart, MoreVertical } from "lucide-react";

/**
 * Inline visual demo for the "How It Works" page — shows how the prayer-count
 * chip appears in three real-world states so first-time users immediately
 * recognise the pattern when they see it on their own dashboard.
 *
 * Mirrors the chip styling from `PrayerCard.jsx` (`text-sage` + HandHeart icon)
 * so the demo stays visually identical to the real product.
 */
const EXAMPLES = [
  {
    request: "Pray for grandma's recovery",
    requestor: "Sarah",
    count: 0,
    note: "No taps yet — the counter stays hidden",
  },
  {
    request: "Job interview Friday",
    requestor: "Daniel",
    count: 1,
    note: "First pray-er added it",
  },
  {
    request: "Family travelling overseas",
    requestor: "Pastor John",
    count: 12,
    note: "Community is rallying around it",
  },
];

export function PrayerCountExamples() {
  return (
    <div
      className="mt-6 space-y-3"
      data-testid="prayer-count-examples"
      aria-label="Examples showing how the prayer counter appears for different request states"
    >
      {EXAMPLES.map((ex) => (
        <div
          key={ex.request}
          data-testid={`prayer-count-example-${ex.count}`}
          className="rounded-xl border border-stone/60 dark:border-stone-dark/50 bg-white dark:bg-stone-dark/40 p-3"
        >
          <div className="flex items-start justify-between gap-2">
            <p className="text-sm font-medium text-stone-dark dark:text-stone-light leading-snug">
              {ex.request}
            </p>
            <MoreVertical className="w-4 h-4 text-stone-dark/30 shrink-0 mt-0.5" />
          </div>
          <div className="mt-1.5 flex items-center gap-3 text-xs text-stone-dark/60 dark:text-stone-light/60">
            <span>By {ex.requestor}</span>
            {ex.count >= 1 && (
              <span
                className="flex items-center gap-1 text-sage"
                title={`${ex.count} ${ex.count === 1 ? "person has" : "people have"} prayed for this`}
              >
                <HandHeart className="w-3 h-3" />
                {ex.count}
              </span>
            )}
          </div>
          <p className="mt-1.5 text-[11px] text-stone-dark/50 dark:text-stone-light/50 italic">
            {ex.note}
          </p>
        </div>
      ))}
    </div>
  );
}
